// extracted by mini-css-extract-plugin
module.exports = {"welfare":"Welfare_welfare_3G3QT"};